import { type ReactElement, type ReactNode } from "react";
import { createPortal } from "react-dom";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { OverlayScrim } from "./OverlayScrim";

export function Popover({
  trigger,
  children,
  open,
  onOpenChange,
  className,
  align = "end",
  scrim = false,
}: {
  trigger: ReactElement;
  children: ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  className: string;
  align?: "start" | "center" | "end";
  // Catches the outside click so it does not reach the page underneath.
  scrim?: boolean;
}) {
  return (
    <PopoverPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <PopoverPrimitive.Trigger asChild>{trigger}</PopoverPrimitive.Trigger>
      {scrim && open
        ? createPortal(
            <OverlayScrim onDismiss={() => onOpenChange(false)} />,
            document.body,
          )
        : null}
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align={align}
          side="bottom"
          sideOffset={4}
          className={className}
          onOpenAutoFocus={(event) => event.preventDefault()}
          onCloseAutoFocus={(event) => event.preventDefault()}
          onEscapeKeyDown={(event) => event.preventDefault()}
        >
          {children}
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
